<div *transloco="let t; read: 'add-tags-dialog'" class="xi-modal__container add-tags__container">
  <h2 class="xi-modal__title">{{ t('add-tags') }}</h2>

  <div class="xi-modal__content add-tags__content">
    <p>
      {{ options().content }}
    </p>

    <p>
      <mat-form-field>
        <input
          matInput
          [formControl]="chipInput"
          [placeholder]="options().placeholder"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addTag($event.value)"
          (paste)="onTextPasted($event)"
        />
      </mat-form-field>

      <xi-fab
        icon="fab_plus"
        color="orca"
        buttonSize="normal"
        [disabled]="!chipInput.value"
        (onClick)="addTag()"
        class="add-tags__fab"
      ></xi-fab>
    </p>

    <p class="tags-form-wrapper">
      <mat-form-field class="tags-form" appearance="fill">
        <mat-chip-grid #chipList [aria-label]="t('tags-to-apply')">
          @for (tag of tags; track tag) {
            <mat-chip-row></mat-chip-row>
            <app-lex-xi-tag
              [text]="tag"
              type="document"
              [canUserDelete]="true"
              (onClick)="removeTag(tag)"
            ></app-lex-xi-tag>
          }
        </mat-chip-grid>
      </mat-form-field>
    </p>
  </div>

  <div class="xi-modal__actions add-tags__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <xi-default-button
      [text]="t('add-tags')"
      [disabled]="hasError || !hasTags"
      (onClick)="confirm()"
    ></xi-default-button>
  </div>
</div>
